module.exports = __webpack_public_path__ + "img/smart-fortwo.35109769.jpg";